export default __webpack_public_path__ + "static/media/line-chart.ff7db311.svg";